/**
 * Linked Sub-TARAs — surfaces `imported_child_taras` from the raw
 * analysis_agent result. Hierarchical-mode projects link to child
 * TARAs (e.g. ADAS Domain Controller, Cockpit Domain Controller)
 * whose findings roll up into this Item Definition.
 *
 * Not present in the backend's structured `format_item_definition_for_display`
 * payload — the field lives on the raw agent output, so WorkflowV2
 * passes it through separately. Hidden for individual-mode projects
 * (the field is undefined).
 */
import React from 'react';
import { SectionCard, SubSection, StringListField, isEmpty } from './parts';

interface LinkedSubTarasProps {
  items?: string[] | null;
  isEditing?: boolean;
}

export default function LinkedSubTaras({ items, isEditing }: LinkedSubTarasProps) {
  // Read-only — child TARA links are managed elsewhere
  // (project linking flow), not editable inline.
  if (isEmpty(items)) return null;

  return (
    <SectionCard title="Linked Sub-TARAs" count={Array.isArray(items) ? items.length : 0} id="linked_sub_taras">
      <SubSection title="Imported child TARAs">
        <StringListField label="Sub-TARAs" items={items} isEditing={false} path={[]} />
      </SubSection>
    </SectionCard>
  );
}
